<template>
  <div id="app-container" :class="this.$store.state.menuType">
    <topnav />
    <sidebar />
    <main>
      <div class="container-fluid">
        <slot></slot>
      </div>
    </main>
  </div>
</template>

<script>
import Sidebar from "../views/navs/Sidebar";
import Topnav from "../views/navs/Topnav";
import { mapGetters } from "vuex";

export default {
  components: {
    topnav: Topnav,
    sidebar: Sidebar,
  },
  computed: {
    ...mapGetters(["MenuTypeLarge", "MenuTypeSmall"]),
  },
  created() {
    window.addEventListener("resize", this.resizeWindow);
    this.resizeWindow();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeWindow);
  },
  mounted() {
    setTimeout(() => {
      document.body.classList.add("default-transition");
    }, 100);
  },
  methods: {
    resizeWindow() {
      if (window.matchMedia("(max-width: 767px)").matches)
        this.$store.commit("setMenuType", this.MenuTypeSmall);
      else this.$store.commit("setMenuType", this.MenuTypeLarge);
    },
  },
};
</script>
